<template>
  <b-modal ref="modal" :hideFooter="true" :hideHeader="true" size="lg" @hidden="onHide" :noCloseOnBackdrop="true">
    <div class="row" v-if="task">
      <div class="col-md-7 col-sm-12">
        <div class="row">
          <div class="col-12 main-container" ref="infoSide">
            <div class="row">
              <div class="col-2">
                <img :src="task.user.photo" class="img-fluid avatar" align="right">
              </div>
              <div class="col-5">
                <span class="user-name">{{ task.user.name }}</span><br>
                <small>{{ task.user.tagline }}</small>
              </div>

              <div class="col-5" style="text-align: right">
                <span class="text-muted action-text" @click="onTaskEdit">Edit</span>
                <span class="text-muted separator"> | </span>
                <span class="text-danger action-text" @click="onTaskDelete">Delete</span>
              </div>
            </div>

            <div class="row mt-4 info">
              <div class="col-5">
                <span class="right-border"><i class="far fa-calendar-alt icon"></i> {{ date }}</span>
                <span class="right-border"><i class="far fa-user icon"></i> {{ task.client.name }}</span>
              </div>
              <div class="col-7">
                <span v-if="fixedPrice && !isSimple">
                  <i class="far fa-money-bill-alt icon"></i>
                  € {{ fixedPrice }}
                </span>
                <span v-else><i class="far fa-clock icon"></i> {{ duration }}</span>
                <span><i class="fas fa-suitcase icon"></i> {{ task.project.name }}</span>
              </div>
              <div class="col-12">
                <hr>
              </div>
            </div>

            <div class="row mt-1" v-if="deadline || task.done">
              <template v-if="task.done">
                <div class="col-6">
                  <strong>Confirmed:</strong>
                  <i class="fas fa-check pl-2 icon-mid" style="color: green;" v-if="task.done_confirmed"></i>
                  <i class="fas fa-times pl-2 icon-mid" style="color: red;" v-else></i>
                </div>
                <div class="col-6" v-if="(!fixedPrice && isSimple) || !isSimple">
                  <strong v-if="task.done_confirmed">Billed for: </strong>
                  <strong v-else>Engineered for: </strong>
                  {{ billed }}
                </div>
              </template>
              <template v-else>
                <div class="col-6" v-if="deadline">
                  <strong>Deadline:</strong> {{ deadline }}
                </div>
              </template>
              <div class="col-12">
                <hr>
              </div>
            </div>

            <div class="row mt-1 mb-5" v-if="task.notes">
              <div class="col-12"><pre style="font-family:sans-serif !important; font-size: 12px;">{{ task.notes }}</pre></div>
            </div>

            <!-- Make space for absolute positioned buttons to prevent overlapping -->
            <div class="row">
              <div class="col-12" :style="{ height: isAdmin && task.done && !task.done_confirmed ? '80px' : '50px'}"></div>
            </div>

            <div class="row mt-5 attach-to-bottom">
              <div class="col-12">
                <div class="text-center mt-3">
                  <template v-if="isAdmin && task.done && !task.done_confirmed">
                    <button class="btn btn-success done-button mb-2" @click="onDoneClick">CONFIRM</button>
                  </template>
                  <template v-if="task.done || task.done_confirmed">
                    <button class="btn btn-warning mr-2 custom-button" @click="onUnDoneClick">MARK AS UNDONE</button>
                  </template>
                  <template v-if="!task.done">
                    <button class="btn btn-success mr-1 custom-button" @click="onDoneClick">MARK AS DONE</button>
                  </template>
                  <button class="btn btn-default custom-button" @click="hide">CANCEL</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-5 comments-container sm-hide">
        <form @submit.prevent="newCommentSubmit">

          <div class="comments" ref="comments">
            <div class="comments-empty" v-if="task.comments.length === 0">
              <i class="far fa-comment-alt" style="font-size: 150px"></i>
              <br>
              <span style="display: inline-block; padding-top: 10px">No comments yet</span>
            </div>
            <div v-else>
              <ul class="comments-list pt-4">
                <template v-for="comment in task.comments">
                  <li class="p-2 mb-2" :class="{ log: comment.log, comment: !comment.log }">
                    <img :src="comment.user ? comment.user.photo : ''" class="comment-photo">
                    <small>{{ comment.created_at | calendarDate }}</small>
                    <small class="pull-right log-text" v-if="comment.log">LOG</small>
                    <br>
                    <div class="pt-2">
                      <span v-html="comment.text"></span>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </div>

          <div class="new-comment form-group">
            <label for="comment">Comment</label>
            <input type="text" id="comment" class="form-control" v-model="newComment" placeholder="Write your comment...">
            <i class="far fa-comment-alt fa-fw" id="submit-comment" @click="newCommentSubmit"></i>
          </div>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import bModal from 'bootstrap-vue/es/components/modal/modal'
  import moment from 'moment'
  import $ from 'jquery'

  import {mapGetters} from 'vuex'

  export default {
    components: {
      'b-modal': bModal
    },
    data() {
      return {
        task_id: null,
        task: null,
        date: null,
        deadline: null,
        duration: null,
        fixedPrice: null,
        newComment: null
      }
    },

    computed: {
      ...mapGetters('auth', ['user', 'isAdmin', 'isSimple']),
      billed() {

        if (this.task.done_confirmed) {
          if (this.task.fixed_price) {
            return this.task.fixed_price + ' €'
          }

          return this.$root.secondsToTimestring(this.task.billable_hours_confirmed)
        }

        if (this.task.done) {
          return this.$root.secondsToTimestring(this.task.engineering_hours)
        }

        return null
      }
    },

    filters: {
      calendarDate(date) {
        return moment(date).calendar()
      },
    },

    methods: {

      open(id) {
        this.task_id = id
        this.$refs.modal.show()
        this.getTask()
      },

      hide() {
        this.$refs.modal.hide()
        this.onHide()
      },

      onTaskDelete() {
        this.$swal({
          title: 'Are you sure?',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          confirmButtonColor: '#dd4b39',
          focusCancel: true,
          reverseButtons: true
        }).then(result => {
          if (result.value) {
            this.deleteTask()
          }
        })
      },

      deleteTask() {
        this.axios.delete('/tasks/' + this.task_id)
          .then(res => {
            this.$emit('taskDeleted', this.task)
            this.$root.$emit('delete-success', res.data.data)
            this.hide()
          })
          .catch(error => {
          })
      },

      onTaskEdit() {
        this.$emit('updateTask', this.task_id)
        this.hide()
      },

      onDoneClick() {
        this.$root.$emit('bill-tasks', this.task)
        this.hide()
      },

      onUnDoneClick() {
        const data = {
          billed_at: null,
          done_confirmed: 0,
          done: 0,
          _method: 'PUT'
        }

        this.axios.post('tasks/' + this.task.id, data)
          .then(res => {
            this.$emit('taskUndone', res.data.data)
            this.$root.$emit('undone-success', res.data.data)
            this.$root.$emit('load-agenda')
            this.hide()
          })
          .catch(error => {
          })
      },

      onHide($event) {
        this.task_id = null,
          this.task = null
        this.date = null
        this.deadline = null
        this.duration = null
        this.newComment = null
      },

      newCommentSubmit() {
        if (this.newComment) {
          const data = {
            user_id: this.user.id,
            task_id: this.task_id,
            comment: this.newComment
          }

          this.axios.post('/comments', data)
            .then(res => {
              const comment = res.data.data
              this.task.comments.push({
                user: comment.user,
                text: comment.comment,
                created_at: comment.created_at,
                log: 0
              })

              this.newComment = null

              Vue.nextTick().then(() => {
                this.$refs.comments.scrollTop = 9999999999
              })
            })
            .catch(error => {
            })
        }
      },

      getTask() {
        this.axios.get('/tasks/' + this.task_id)
          .then(res => {
            const task = res.data.data
            this.task = task
            this.date = moment(task.date).format('DD MMM YYYY')
            this.duration = this.$root.secondsToTimestring(task.duration)
            this.fixedPrice = task.fixed_price
            this.deadline = task.deadline ? moment(task.deadline).format('DD MMM YYYY') : null

            Vue.nextTick().then(() => {
              const height = this.$refs.infoSide.clientHeight - 100
              this.$refs.comments.style.height = height + 'px'

              this.$refs.comments.scrollTop = 9999999999
            })
          })
          .catch(error => {
          })
      }
    }
  }
</script>

<style scoped>

  .log {
    background: #DFDBFF;
  }

  .log:hover {
    background: #C1BEE1;
  }

  .comment:hover {
    background: #EBEBEB;
  }

  .log-text {
    font-weight: bold;
  }

  .comments-container {
    background: #F9F9F9;
    position: relative;
  }

  .main-container {
    min-height: 400px;
  }

  .attach-to-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  .comments {
    overflow-y: auto;
  }

  .comments-list {
    text-align: left;
    list-style: none;
    padding-left: 0;
  }

  .new-comment {
    border-top: #929396 1px solid;
    position: absolute;
    width: 90%;
    padding-top: 10px;
    height: 120px;
    margin: auto;
    bottom: -30px;
  }

  .comment-photo {
    height: 30px;
    width: 30px;
    border-radius: 15px;
  }

  .comments-empty {
    color: #7B7B7B;
    text-align: center;
    padding-top: 10%;
  }

  #submit-comment {
    position: relative;
    z-index: 1;
    left: 90%;
    bottom: 27px;
    color: #7B7B7B;
    cursor: pointer;
    width: 0;
  }

  .info span {
    display: block;
    margin-bottom: 10px;
  }

  .right-border {
    width: 100%;
    border-right: #F2F2F2 1px solid;
  }

  .action-text {
    cursor: pointer;
    font-weight: bolder;
  }

  .action-text:hover {
    text-decoration: underline;
  }

  .separator {
    padding-right: 5px;
    padding-left: 5px;
    display: inline-block;
    cursor: default;
  }

  .custom-button {
    width: 40%;
    border-radius: 5%;
    white-space: normal;
  }

  .done-button {
    width: 82%;
    border-radius: 5%;
    white-space: normal;
  }

  .avatar {
    height: 50px;
    width: 50px;
    border-radius: 25px;
  }

  .user-name {
    font-weight: bold;
  }

  .icon {
    font-size: 1.7rem;
    display: inline-block;
    padding-right: 5px;
  }

  .icon-mid {
    position: relative;
    top: 2px;
    font-size: 1.5rem
  }

</style>




// WEBPACK FOOTER //
// src/views/agenda/ViewTask.vue